import { useCallback } from 'react'

import { TanstackField } from 'src/utils/forms'

import RecordTypeStatusSelect from '../../Selects/RecordTypeStatusSelect'

type Props<TKey extends string> = {
  field: TanstackField<number | null | undefined, TKey>
  isClearable?: boolean
  isDisabled?: boolean
  isRequired?: boolean
  label?: string
  recordTypeId: number | null | undefined
}
const RecordTypeStatusSelectField = <TKey extends string>({
  field,
  isClearable,
  isDisabled,
  isRequired,
  label,
  recordTypeId,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  const handleValueChange = useCallback(
    (v: number | null | undefined) => {
      field.setValue(v ?? null)
    },
    [field]
  )

  return (
    <RecordTypeStatusSelect
      errorMessage={errorMessage}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={handleValueChange}
      recordTypeId={recordTypeId}
      value={field.state.value}
    />
  )
}

export default RecordTypeStatusSelectField
